import React, { Component } from 'react';
import axios from 'axios';
import {
  getIssues,
  getProject,
  getAssisantSkills,
  updateSkill,
  submitTokenData,
  getUserToken,
  getUser,
  // addBasicAuth,
  setSkill,
  setCurrentSkill,
  updateAssisantSkills,
  searchJiraProjects,
  checkJiraTokenValidity,
} from '../skills_action';

import { adminOauthToken } from '../../jiraoauth/jiraoauth.action';

import DefaultsSelection from './defaultsSelection';
import {
  DeleteOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons';
// import { Form } from '@ant-design/compatible';
import { setWorkspace } from '../../common/common_action';
import JiraBilling from '../../billing/jiraBilling';
import JiraPersonalNotification from './presonal_notification';
// import {
//   getJiraGuestManager,
//   getJiraGuestUsers
// } from "./jira_guest_config/jiraGuestAction";

// import '@ant-design/compatible/assets/index.css';
import './jira.css';
import {
  Form,
  Button,
  Modal,
  Card,
  message,
  Input,
  Row,
  Col,
  Alert,
  Dropdown,
  Menu,
  Layout,
  Popconfirm,
  Switch,
  Typography,
  List,
  Anchor,
  Tooltip,
  Tag,
  Divider,
  Space,
} from 'antd';
import moment from 'moment';
import {
  ExclamationCircleOutlined,
  InteractionTwoTone,
  StopOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import JiraServerModal from './jira_server_modal';
import JiraToken from '../jira/jiraConnectionFlow/jiraToken';
import jwt from 'jsonwebtoken';
// import CustomEmojiForCreation from "./CustomEmojisForIssueCreation"
import { guestOauthTokensForUsers } from '../../jiraoauth/jiraoauth.action';
import { getGuestOauthTokensForCloudUsers } from '../../jiraoauth/jiraOAuthCloud.action';
import GlobalGuestTokenRestriction from './GuestUserRestriction';
import queryString from 'query-string';
import RequestTypeRestriction from './requestTypeRestriction';
import ProjectRestriction from './projectRestriction';
import ProxyUrlModal from './proxyUrlModal';

const { SubMenu } = Menu;
const { Content } = Layout;
const { Text, Title } = Typography;
const { Link } = Anchor;
// const { Option } = Select;
const attributeText =
  'Created by Troopr from @@@slack_message_link@@@ posted by @@@user@@@ in @@@#slack_channel_name@@@';
class JiraConfiguration extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loadingUser: false,
      loadingToken: false,
      channels: [],
      projects: [],
      issues: [],
      defaultProject: '',
      defaultIssue: '',
      skillsToggle: false,
      notificationToggle: false,
      personalNotifToggle: false,
      preference: 'channel',
      selectedChannel: '',
      selectedChannelName: '',
      selectedProject: '',
      currentSkill: this.props.match.params.skill_id,
      linkedProject: null,
      linkedIssue: null,
      personalProject: '',
      personalIssue: '',
      personalChannelId: '',
      edit: false,
      error: {},
      showChannelSetting: false,
      disconnectModel: false,
      searchChannel: '',
      value: '',
      suggestions: [],
      getToken: false,
      userName: '',
      userToken: '',
      adminUserName: '',
      adminMailId: '',
      adminUserId: '',
      newConnectionModal: false,
      loading: false,
      isUnfurlLink: false,
      isAdmin: false,
      isThreadSyncUnfurl: false, // Only for unfurl
      isThreadSyncTaskIt: false, // Only for task it
      loadingPricing: false,
      payment: {},
      urlModal: false,
      doamin_url: '',
      connections: [],
      gridLoading: false,
      isUnfurl: false,
      unfurlResponseInThread: false,
      taskItResponseInThread: false,
      createCommandResponseConfig: false,
      isSoftwareEnabled: true,
      isServiceDeskEnabled: true,
      showStatusUpdateInThread: true,
      jqlFilter: [],
      isJqlFilterModalVisible: false,
      jqlFilterName: '',
      jqlFilterExp: '',
      jqlFilterModalStatus: '',
      jqlFilterId: '',
      isJqlFilterActionButtonDisabled: false,
      projectLoading: false,
      showAttributeText: false,
      attributeText: '',
      showAttributeTextField: false,
      previousDomainUrl: '',
      proxyUrlModal: false,
    };
    this.onChangeChannel = this.onChangeChannel.bind(this);
    this.goToJiraNotifSetup = this.goToJiraNotifSetup.bind(this);
    this.updateSkill = this.updateSkill.bind(this);
    this.showChannelSetting = this.showChannelSetting.bind(this);
  }

  async componentDidMount() {
    // console.log("MOUNTED ",this.props.skill)
    // this.fetchJqlFilter();
    if (this.props.match.params.sub_skill === 'jira_software')
      this.getRequiredData();

    /*axios.get(`/api/${this.props.match.params.wId}/isAdmin`).then(res => {
       if(res.data.success && res.data.isAdmin){
         this.setState({isAdmin : true});
       }
     })*/

    // this.props.getProject(this.props.workspace_id);
    let {
      isUnfurl,
      isUnfurlLink,
      unfurlResponseInThread,
      taskItResponseInThread,
      createCommandResponseConfig,
      isThreadSyncUnfurl,
      isThreadSyncTaskIt,
      isSoftwareEnabled,
      isServiceDeskEnabled,
      showStatusUpdateInThread,
      attributeText,
      showAttributeText,
    } = this.props.skill;
    this.setState({
      isUnfurl,
      isUnfurlLink,
      unfurlResponseInThread,
      taskItResponseInThread,
      createCommandResponseConfig,
      isThreadSyncUnfurl,
      isThreadSyncTaskIt,
      isSoftwareEnabled,
      isServiceDeskEnabled,
      showStatusUpdateInThread,
      attributeText: attributeText,
      showAttributeText,
      showAttributeTextField: false,
    });
    let { skill } = this.props;
    let isLinked = skill.skill_metadata
      ? skill.skill_metadata.linked
      : skill.linked;
    if (isLinked) {
      let domainname = skill.skill_metadata
        ? skill.skill_metadata.metadata.domain_name
        : skill.metadata.domain_name;
      let jiraUrl = skill.skill_metadata
        ? skill.skill_metadata.metadata.domain_url
        : skill.metadata.domain_url
          ? skill.metadata.domain_url
          : `https://${domainname}.atlassian.net`;

      this.setState({ domain_url: jiraUrl });
    } else {
      this.getExistingGridConnections();
    }

    this.setState({ loadingPricing: true });

    // app.get('/api/:wId/grid_jira_connections', function (req, res) {
    //   SkillMetadata.getGridJiraConnections(req, res)
    // });

    axios
      .get('/auth/troopr_billing/payementInfo/' + this.props.match.params.wId)
      .then((data) => {
        let billing = data && data.data ? data.data : {};
        // let pricings = data[1].data.pricings
        // let jSkills=data[2].data
        // let skill = jSkills.skill
        // const allCheckInsData = data[3].data;
        // let activeCheckins = 0;
        // if(allCheckInsData.teamSyncs){
        //   allCheckInsData.teamSyncs.forEach(checkin => {
        //     checkin.createInstance && activeCheckins++
        //   })
        // }
        // console.log(data,users,billing)
        if (billing && billing.paymentInfo)
          this.setState({
            payment: billing.paymentInfo,
            loadingPricing: false,
          });
      });

    // let activeUsers = axios.get("/auth/troopr_billing/getActiveUsers/" + this.props.match.params.wId)

    // const checkInsPromise = axios.get('/api/getUsersSelectedTeamSync/' + this.props.match.params.wId +"?showAll=true")

    // Promise.all([billingPromise, pricing]).then(data => {
    //isUnfurlLink=>GET

    // let isUnfurlLink=await axios.get(`/bot/workspace/isUnfurlLink/${this.props.match.params.wId}`)
    // // console.log(isUnfurlLink)
    // if(isUnfurlLink){
    //   this.setState({isUnfurlLink:isUnfurlLink.data.data})
    // }

    // let isThreadSyncStatus=await axios.get(`/bot/workspace/isThreadSyncStatus/${this.props.match.params.wId}`)
    // // console.log(isUnfurlLink)
    // if(isThreadSyncStatus){
    //   this.setState({isThreadSync:isThreadSyncStatus.data.data})
    // }
    //
    if (this.props.isFromCheckins) {
    } else {
      this.setState({ loadingUser: true });
      this.props
        .getUser(
          this.props.match.params.wId,
          this.props.skill.skill_metadata
            ? this.props.skill.skill_metadata.jiraConnectedId
            : this.props.skill.jiraConnectedId
        )
        .then((res) => {
          // console.log("pulled admin user info:" + JSON.stringify(res))
          // console.log("connectorUser: ", res.data);
          this.setState({ loadingUser: false });
          // console.log("componentDidMount:props.getUser(" + this.props.skill.jiraConnectedId + ")" + JSON.stringify(res.data))
          if (res.data.user) {
            this.setState({
              adminUserName: res.data.user.displayName || res.data.user.name,
              adminMailId: res.data.user.email,
              adminUserId: res.data.user.user_id,
            });
          }
        });
    }
    if (this.props.isFromCheckins) {
    } else {
      this.setState({ loadingToken: true });
      let name = 'Jira';
      this.props
        .getUserToken(this.props.match.params.wId, name)
        .then((userData) => {
          // console.log("====>userData",userData)
          this.setState({ loadingToken: false });
          if (userData.data && userData.data.userToken) {
            this.setState({
              userName: userData.data.userName,
              userToken: userData.data.userToken,
            });
          } else {
            this.setState({
              userName: '',
              userToken: '',
            });
          }
        });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.match.params.sub_skill !== this.props.match.params.sub_skill
    ) {
      if (this.props.scrollContentRef && this.props.scrollContentRef.current)
        this.props.scrollContentRef.current.scrollTo(0, 0);
      if (this.props.match.params.sub_skill === 'jira_software')
        this.getRequiredData();

      //reset the unsaved Attribution Input field while switching to project to helpdesk connection page or vice versa
      if (
        prevProps &&
        prevProps.skill &&
        prevProps.skill.attributeText &&
        prevState.showAttributeTextField === true
      ) {
        this.setState({
          attributeText: prevProps.skill.attributeText,
          showAttributeTextField: false,
        });
      }
    }

    // if(prevProps && prevProps.skill){
    //   if(prevProps.skill.attributeText !== this.props.skill.attributeText) {
    //     this.setState({attributeText: this.state.attributeText})

    //   }
    // }
    // console.log(prevProps.skill.attributeText !== this.state.attributeText, this.props.skillView)
    // console.log(`prevProps ${prevProps.skill.attributeText}, prevstate"\n \n ",${prevPr.attributeText}, "\n \n",${this.state.attributeText}`)
  }

  getRequiredData = () => {
    const jiraSkill = this.props.skills.find((skill) => skill.name === 'Jira');
    if (
      jiraSkill &&
      jiraSkill.skill_metadata.metadata &&
      jiraSkill.skill_metadata.metadata.server_type
    ) {
      this.setState(
        {
          server_type: jiraSkill.skill_metadata.metadata.server_type,
          projectLoading: true,
        },
        () => {
          if (
            this.state.server_type === 'jira_server_oauth' ||
            this.state.server_type === 'jira_server'
          ) {
            this.props
              .getProject(this.props.match.params.wId)
              .then((res) => this.setState({ projectLoading: false }));
          } else {
            this.props
              .searchJiraProjects(
                this.props.match.params.wId,
                this.props.match.params.sub_skill === 'jira_software'
                  ? ''
                  : '?query=typeKey=service_desk'
              )
              .then((res) => {
                if (
                  res.data.success &&
                  res.data.projectsData &&
                  res.data.projectsData.values
                )
                  this.setState({ projectLoading: false });
              });
          }
        }
      );
    }
  };

  showChannelSetting() {
    this.props.setOption(
      'jira_channel_pref',
      this.state.selectedChannel,
      this.state.selectedChannelName
    );
  }

  disconnectOnClickModel = async () => {
    const { skill } = this.props;

    let currentUserId = localStorage.getItem('trooprUserId');
    let workspaceId = this.props.workspace_id;

    // console.log('workspace_id -> ', workspaceId);

    /*try{
      let res = await axios.get(`/api/${workspaceId}/isAdmin`);
      if(res){
        if(res.data.success && res.data.isAdmin){
          // console.log("setting this.state.isAdmin to true");
          this.setState({
            isAdmin : true
          })
        }
      }
      // else{
      //   console.log("no response from api");
      // }
    }catch(err){
      console.error("api call to /api/:userId/isAdmin failed with error: ",err);
    }*/

    let isAdmin = this.props.isWorkspaceAdmin;

    let jiraConnectedId =
      skill && skill.skill_metadata
        ? skill.skill_metadata.jiraConnectedId
        : skill.jiraConnectedId;

    // console.log("this.state.isAdmin -> ",this.state.isAdmin);

    //  let jiraConnectedId = this.props.skill.jiraConnectedId
    //if ((currentUserId === jiraConnectedId) || this.state.isAdmin) {
    if (currentUserId === jiraConnectedId || isAdmin) {
      // message.okText("Disconnection authorized");
      // console.log("disconnection authorized!");
      this.setState({ disconnectModel: !this.state.disconnectModel });
    } else {
      // console.log("failed to disconnect as you are not the conection owner");
      message.error('Please contact your Jira Admin to disconnect');
    }
  };

  unfurlOptionsHandler = async (name) => {
    if (!name) return;

    let data = {};
    let value = !this.state[name];
    data = {
      name: name,
      value,
    };

    // let response = await axios.post(`/bot/workspace/unfurlToggles/${this.props.match.params.wId}`, data);
    let response = await axios.post(
      `/bot/api/w/${this.props.match.params.wId}/workspace/unfurlToggles`,
      data
    );
    if (response) {
      // console.log(response)
      if (response.data && response.data.success) {
        this.setState({
          ...response.data.data,
        });
        let options = response.data.data;
        let skill = this.props.skill;
        skill = { ...skill, ...options };
        this.props.setSkill(skill);
        this.props.setCurrentSkill(skill);
      }
    }
  };

  // enableDisableProduct = async(product)=>{
  //   let data = {};
  //   let value = !this.state[product];
  //   product === "isServiceDeskEnabled"?
  //   data = {
  //     "isServiceDeskEnabled" : value
  //   }:
  //   data = {
  //     "isSoftwareEnabled" : value
  //   }
  //   this.props.updateSkill(this.props.skill._id, this.props.skill.workspace_id, data).then(res => {
  //     if(res.data.success){
  //       this.setState(data);
  //       this.props.setSkill(res.data.skill);
  //       this.props.setCurrentSkill(res.data.skill);
  //     }
  //   });
  // }
  switchButtonStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 'bold',
  };

  getExistingGridConnections() {
    // axios.get("/bot/api/" + this.props.match.params.wId + "/grid_jira_connections").then(data => {
    axios
      .get(
        '/bot/api/w/' +
        this.props.match.params.wId +
        '/jira/grid_jira_connections'
      )
      .then((data) => {
        this.setState({ gridLoading: false });
        if (data.data.success) {
          this.setState({ connections: data.data.skills });
        }
      });
  }

  fetchJqlFilter = async () => {
    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      // const jqlFilter = await axios.get(`/bot/api/${this.props.match.params.wId}/jqlfilter`, headers);
      const jqlFilter = await axios.get(
        `/bot/api/w/${this.props.match.params.wId}/jira/jqlfilter`,
        headers
      );
      if (!!jqlFilter.data.success) {
        this.setState({
          jqlFilter: jqlFilter.data.data[0].filters,
        });
      }
    } catch (error) { }
  };

  addJqlFilter = () => {
    if (
      this.state.jqlFilterName.trim() != '' &&
      this.state.jqlFilterExp.trim() != ''
    ) {
      let isUsed =
        this.state.jqlFilter &&
        this.state.jqlFilter.find(
          (el) => el.filterName === this.state.jqlFilterName
        );
      if (isUsed) {
        if (
          this.state.jqlFilterModalStatus === 'UPDATE' &&
          this.state.jqlFilterId === (isUsed && isUsed._id)
        ) {
        } else {
          return message.error(
            'Jql Filter name is already used, Please use different name.'
          );
        }
      }

      if (this.state.jqlFilterModalStatus === 'ADD') {
        this.jqlFilterOps({
          filterName: this.state.jqlFilterName,
          jqlFilter: this.state.jqlFilterExp,
          filterId: null,
        });
      }
      if (this.state.jqlFilterModalStatus === 'UPDATE') {
        if (this.state.jqlFilterId.trim() != '') {
          this.jqlFilterOps({
            filterId: this.state.jqlFilterId,
            filterName: this.state.jqlFilterName,
            jqlFilter: this.state.jqlFilterExp,
          });
        } else {
          message.error('jql filter id missing');
        }
      }
    } else {
      message.warn('Please fill all details');
    }
  };

  createJqlFilter = async ({ filterName, jqlFilter }) => {
    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const body = {
      workspaceId: this.props.match.params.wId,
      filters: [
        {
          filterName,
          jqlFilter,
        },
      ],
    };

    try {
      // const jqlFilter = await axios.post(`/bot/api/jqlfilter`, body, headers);
      const jqlFilter = await axios.post(
        `/bot/api/w/${this.props.match.params.wId}/jira/jqlfilter`,
        body,
        headers
      );
      // /bot/api//w/:wId/jira/jqlfilter
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        this.toggleJqlFilterModal();
        this.fetchJqlFilter();
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) { }
  };

  editJqlFilter = async ({ filterName, jqlFilter, filterId }) => {
    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const body = {
      workspaceId: this.props.match.params.wId,
      filterName,
      jqlFilter,
      filterId,
    };

    try {
      const jqlFilter = await axios.put(`/bot/api/jqlfilter`, body, headers);
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        this.toggleJqlFilterModal();
        this.fetchJqlFilter();
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) { }
  };

  addJqlFilterOnExist = async ({ filterName, jqlFilter }) => {
    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const body = {
      workspaceId: this.props.match.params.wId,
      filterName,
      jqlFilter,
    };

    try {
      const jqlFilter = await axios.post(
        `/bot/api/jqlfilter/add`,
        body,
        headers
      );
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        this.toggleJqlFilterModal();
        this.fetchJqlFilter();
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) { }
  };
  goToJiraLogin = async () => {
    const { skill } = this.props;

    // let servertype = skill && skill.metadata && skill.metadata.server_type

    // if (servertype && servertype === "jira_server_oauth") {

    let url = await adminOauthToken(
      this.props.match.params.wId,
      this.props.match.params.sub_skill
    );
    if (!url) {
      message.error(
        'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
      );
    } else {
      window.open(url, '_blank');
    }

    // else {
    //   const url = `/${this.props.match.params.wId}/jira_user_oauth/${this.props.match.params.skill_id}`;
    //   window.open(url, "_blank");
    // }

    /*this.props.history.push("/workspace/"+this.props.workspace_id+"/jira_user_oauth/"+this.props.skill._id)*/
  };
  jqlFilterOps = async ({ filterName, jqlFilter, filterId }) => {
    this.setState({
      isJqlFilterActionButtonDisabled: true,
    });

    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const body = {
      workspaceId: this.props.match.params.wId,
      filterName,
      jqlFilter,
      filterId,
    };

    try {
      // const jqlFilter = await axios.post(`/bot/api/jqlfilter`, body, headers);
      const jqlFilter = await axios.post(
        `/bot/api/w/${this.props.match.params.wId}/jira/jqlfilter`,
        body,
        headers
      );
      this.setState({
        isJqlFilterActionButtonDisabled: false,
      });
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        this.toggleJqlFilterModal();
        this.fetchJqlFilter();
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) {
      this.setState({
        isJqlFilterActionButtonDisabled: false,
      });
      message.error('Something went wrong! Please try again later');
    }
  };

  removeJqlFilter = async () => {
    const token = await localStorage.getItem('token');

    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const filterId = this.state.jqlFilterId;

    try {
      // const jqlFilter = await axios.delete(`/bot/api/${this.props.match.params.wId}/jqlfilter/${filterId}`, headers);
      const jqlFilter = await axios.delete(
        `/bot/api/w/${this.props.match.params.wId}/jira/jqlfilter/${filterId}`,
        headers
      );
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        this.toggleJqlFilterModal();
        this.fetchJqlFilter();
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) {
      message.error('Something went wrong! Please try again later');
    }
  };

  openJqlFilterModal = (filter = null) => {
    if (filter != null) {
      this.setState(
        {
          jqlFilterName: filter.filterName,
          jqlFilterExp: filter.jqlFilter,
          jqlFilterId: filter._id,
          jqlFilterModalStatus: 'UPDATE',
        },
        () => {
          this.toggleJqlFilterModal();
        }
      );
    } else {
      this.setState(
        {
          jqlFilterModalStatus: 'ADD',
        },
        () => {
          this.toggleJqlFilterModal();
        }
      );
    }
  };

  toggleJqlFilterModal = () => {
    this.setState(
      {
        isJqlFilterModalVisible: !this.state.isJqlFilterModalVisible,
      },
      () => {
        if (!this.state.isJqlFilterModalVisible) {
          this.setState({
            jqlFilterName: '',
            jqlFilterExp: '',
            jqlFilterId: '',
          });
        }
      }
    );
  };

  onChangeChannel = (event, value) => {
    //value gets all the props
    //event gets the value props
    this.setState({
      selectedChannel: event,
      selectedChannelName: value.props.children,
    });
  };

  goToJiraNotifSetup() {
    this.props.history.push(
      '/' +
      this.props.workspace_id +
      '/jira_notification_setup/' +
      this.props.match.params.skill_id +
      '?step=intial_setup'
    );
  }

  updateSkill(data) {
    const { skill, workspace, skills } = this.props;
    // let skillId = skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
    // let wId = skill && skill.skill_metadata ? skill.skill_metadata.workspace_id : skill.workspace_id;
    let skillId =
      skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
    let wId =
      skill && skill.skill_metadata
        ? skill.skill_metadata.workspace_id
        : skill.workspace_id;

    this.props.updateSkill(skillId, wId, data).then((res) => {
      this.setState({ disconnectModel: !this.state.disconnectModel });
      const jiraSkill = skills.find((skill) => skill.name === 'Jira');
      if (jiraSkill.skill_metadata.disabled) {
        if (res.data.success)
          this.props.updateChecinIntegrationsData(res.data.skill);
        this.props.history.push(
          '/' +
          this.props.workspace_id +
          '/teamsyncs/' +
          'integrations/' +
          this.props.currentSkill._id
        );
      } else
        this.props.history.push(
          '/' +
          this.props.workspace_id +
          '/skills/' +
          this.props.currentSkill._id +
          `/${this.props.match.params.sub_skill}`
        );
    });
  }

  updateSkillData = (data) => {
    this.props
      .updateSkill(
        this.props.match.params.skill_id,
        this.props.match.params.wId,
        data
      )
      .then((res) => { });
  };

  onChangeSearch = (event) => {
    this.setState({ searchChannel: event.target.value });
  };

  validateEmail = (data) => {
    let errors = {};
    if (Validator.isEmpty(data)) {
      errors.isEmail = 'This field is required';
    } else if (!Validator.isEmail(data)) {
      errors.isEmail = 'Email is invalid';
    }

    this.setState({
      error: errors,
    });
    return isEmpty(errors);
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  getToken = () => {
    this.setState({
      userName: this.props.userToken.userName
        ? this.props.userToken.userName
        : '',
      userToken: this.props.userToken.userToken
        ? this.props.userToken.userToken
        : '',
      getToken: true,
    });
  };

  // Delete token Start
  deleteToken = () => {
    const { skill } = this.props;
    let token = localStorage.getItem('token');
    let userinfo = jwt.decode(token);
    let jiraConnectedId =
      skill && skill.skill_metadata
        ? skill.skill_metadata.jiraConnectedId
        : skill.jiraConnectedId;

    if (userinfo._id == jiraConnectedId) {
      let skillId =
        skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
      let wId =
        skill && skill.skill_metadata
          ? skill.skill_metadata.workspace_id
          : skill.workspace_id;
      this.setState({ loading: true });
      this.props
        .updateSkill(
          skillId,
          wId,
          { userName: null, userToken: null },
          this.props.currentSkill
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({ loading: false });
            message.success('Token deleted');
          }
        });
    } else {
      message.error(
        'You are not having permission to delete token.Contact your jira admin.'
      );
    }
  };
  // Delete token End

  doNotShowModal = () => {
    this.setState({
      getToken: false,
    });
  };

  getUserName = (event) => {
    // if(event.target.value){
    this.setState({
      userName: event.target.value,
    });
    // }
  };

  getUserToken = (event) => {
    // console.log("event--->",event.target.value)
    // if(event.target.value){
    this.setState({
      userToken: event.target.value,
    });
    // }
  };

  submitTokenData = () => {
    this.invokeChildMethod();
  };

  // connectUrl = () => {
  //   this.props
  //     .getSkillConnectUrl(this.props.skill.name, this.props.workspace_id)
  //     .then(res => {
  //       if (res.data.success) {
  //         var url = res.data.url;
  //         window.open(url, "_blank");
  //         let data = {
  //           name: this.props.skill.name,
  //           connectUserId: localStorage.getItem("trooprUserId")
  //         };
  //         let wId = this.props.workspace_id;
  //         this.props.setJiraConnectId(wId, data);
  //       }
  //     });
  // };

  addGridToken = async (id) => {
    //  axios.post('/bot/api/'+this.props.match.params.wId+'/jira_grid_token/'+this.props.skill._id+"?token_id="+id).then(res=>{
    axios
      .post(
        '/bot/api/w/' +
        this.props.match.params.wId +
        '/jira/jira_grid_token/' +
        this.props.skill._id +
        '?token_id=' +
        id
      )
      .then((res) => {
        if (res.data.skill) {
          this.props.setSkill(res.data.skill);
          this.props.setCurrentSkill(res.data.skill);
          this.props.updateAssisantSkills(res.data.skill);
        } else {
          message.error('There was a error connecting Jira.');
        }
      });
  };
  // Jira New Connection Start
  // Menu Start
  getGridItem = (connection) => {
    const { isWorkspaceAdmin } = this.props;
    let currentUserId = this.props.currentUser._id;
    if (isWorkspaceAdmin || (connection.jiraConnectedId && connection.jiraConnectedId.toString() === currentUserId.toString())) {

      return <Popconfirm
        title={
          <div>
            Are you sure you want to use the following Jira
            connection from the Grid?
            <br />
            <b>Jira domain: {connection.url}</b>
            {connection.connected_as && <br />}
            {connection.connected_as &&
              `Connected as: ${connection.connected_as.displayName
              } ${connection.connected_as.emailAddress
                ? `(${connection.connected_as.emailAddress})`
                : ''
              }`}
            <br />
            Are you sure?
            <br />
          </div>
        }
        onConfirm={() => this.addGridToken(connection._id)}
        okText='Yes'
        cancelText='No'
      >
        {connection.url}
      </Popconfirm>

    } else {
      return <div onClick={this.showError}>  {connection.url}</div>





    }

  }
  showError = () => {

    message.error(
      'Only Workspace administrators or Jira connection owner can perform this action.'
    )

  }
  // Menu Start
  menu = () => {


    return (
      <Menu>
        <Menu.Item key='0'>
          <a onClick={this.jiraOAuthCloudPage}>New Jira Cloud Connection</a>
        </Menu.Item>
        {/* <Menu.Item key="1">
            <a onClick={this.openConnectModal}>New Jira Server/Data Center Connection</a>
          </Menu.Item> */}
        <Menu.Item key='2'>
          <a onClick={this.jiraoauthConnectionPage}>
            New Jira Server/Data Center Connection
          </a>
        </Menu.Item>

        {this.state.connections.length > 0 && (
          <>
            <Menu.Divider />
            <SubMenu title='Use existing from Grid'>
              <Menu.ItemGroup title='Jira connections in Grid'>
                {this.state.connections.map((connection) => (
                  <Menu.Item key={connection._id}>
                    {this.getGridItem(connection)}

                  </Menu.Item>
                ))}
              </Menu.ItemGroup>
            </SubMenu>
          </>
        )}
      </Menu>
    );
  };

  // Menu End
  openConnectModal = () => {
    this.setState({ newConnectionModal: true });
  };

  jiraoauthConnectionPage = () => {
    // console.log(this.props)
    this.props.history.push(
      `/${this.props.match.params.wId}/jiraoauthServer/${this.props.match.params.skill_id}/0?sub_skill=${this.props.match.params.sub_skill}`
    );
  };
  jiraOAuthCloudPage = () => {
    this.props.history.push(
      `/${this.props.match.params.wId}/jiraOAuthCloud/${this.props.match.params.skill_id}/0?sub_skill=${this.props.match.params.sub_skill}`
    );
  };

  handleCancel = () => {
    this.setState({ newConnectionModal: false });
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  // getPaymentText=()=>{
  //   const {payment}=this.state
  //   let text=""
  // if(payment.payment_app=="jira"){

  //   if(payment.plan_status=="active"){

  //    text=<>Current Status: <Tag color="green">Paid</Tag></>
  //   }else if(payment.plan_status=="trial"){
  //     text=<> Current Status: <Tag color="blue">Evaluation</Tag></>

  //   }else{
  //     text=<> Current Status: <Tag color="red">Eval Expired</Tag></>
  //   }
  // }else{

  // text=<>Current Status:  <br />
  //   <br />
  //   Click on Sync button to fetch license information from the
  //   installed Troopr plugin in the connected Atlassian
  //   account. Please ensure that you have necessary
  //   administrative access for the same.</>
  // }
  // return text

  // }

  updatePayment = (payment) => {
    this.setState({ payment: payment });
  };
  // syncJiraLicense=()=>{
  //   axios.get("/bot/api/"+ this.props.match.params.wId+"/getLicenseStatus").then(data => {
  //     let billing = data.data
  //     if(billing.success){
  //       // console.log(billing.payment.payment)
  //       this.setState({ payment: billing.payment.payment })
  //       setWorkspace(billing.payment.payment.workspace_id)
  //     }else{
  //       message.error(billing.err );
  //     }

  //   })
  // }
  // handleCreate = () => {

  //   const { form } = this.formRef.props;
  //   form.validateFields((err, values) => {
  //     if (err) {
  //       return;
  //     }

  //     // console.log('Received values of form: ', values);
  //     let currentWorkspaceId = localStorage.getItem("userCurrentWorkspaceId");

  //     //----------------------------------------------
  //     // bcrypt.hash(values.password,10,(err,hash)=>{
  //     //----------------------------------------------

  //       this.props.addBasicAuth(currentWorkspaceId, this.props.match.params.skill_id, {
  //         username: values.username,
  //         password: values.password,
  //         domain_url: values.url
  //       }).then(res => {
  //         if (res.data.success) {

  //           this.setState({ newConnectionModal: false })
  //           form.resetFields();
  //           //
  //         let skillMeta=this.props.skill.skill_metadata?this.props.skill.skill_metadata:this.props.skill
  //         // console.log(skillMeta)
  //          let  jiraUrl = skillMeta.metadata.domain_url;
  //         //  let  jiraDomainName = jiraUrl;
  //            this.props.history.push("/"+this.props.match.params.wId+"/jiraConnectionSteps/"+skillMeta._id+`?domainName=${jiraUrl}`)
  //           // this.setState({ loadingUser: true });

  //           // this.props
  //           //   .getUser(
  //           //     this.props.skill.skill_metadata
  //           //       ? this.props.skill.skill_metadata.jiraConnectedId
  //           //       : this.props.skill.jiraConnectedId
  //           //   )
  //           //   .then(res => {
  //           //     this.setState({ loadingUser: false });
  //           //     if (res.data.user) {
  //           //       this.setState({
  //           //         adminUserName: res.data.user.name, adminMailId: res.data.user.email
  //           //       });
  //           //     }
  //           //   });
  //           //
  //         }
  //         else {
  //           message.error("Credentials incorrect, Try again")
  //         }
  //       })
  //     //----------------------------------------------
  //   //  })
  //     //----------------------------------------------
  //   });
  // };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };
  // Jira New Connection End
  acceptMethods = (invokeChildMethod) => {
    this.invokeChildMethod = invokeChildMethod;
  };
  urlModalToggle = () => {
    if (this.state.urlModal === false) {
      this.setState({ previousDomainUrl: this.state.domain_url });
    } else {
      this.setState({ domain_url: this.state.previousDomainUrl });
    }
    this.setState({ urlModal: !this.state.urlModal });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getSubdomainFromUrl = (urlString) => {
    const url = new URL(urlString);
    const hostname = url.hostname;
    const parts = hostname.split('.');
    const subdomain = parts.length > 2 ? parts[0] : null;
    return subdomain;
  };

  submitNewUrl = () => {
    let obj = {
      'metadata.domain_url': this.state.domain_url,
      'metadata.domain_name': this.getSubdomainFromUrl(this.state.domain_url),
    };
    let { skill } = this.props;
    let skillId =
      skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
    let wId =
      skill && skill.skill_metadata
        ? skill.skill_metadata.workspace_id
        : skill.workspace_id;
    this.props
      .updateSkill(skillId, wId, obj, this.props.currentSkill)
      .then((res) => {
        if (res.data.success) {
          this.setState({ urlModal: !this.state.urlModal });
          message.success('Site URL updated to :' + this.state.domain_url);
        }
      });
  };

  onVerifyConnectionClick = async () => {
    let skillId = this.props.match.params.skill_id;
    let workspaceId = this.props.match.params.wId;
    let userId = localStorage.trooprUserId;

    let resp = checkJiraTokenValidity({ skillId, wId: workspaceId });
    resp.then((res) => {
      if (res.data.success) {
        Modal.success({
          title: 'Connection token is Valid',
        });
      } else {
        Modal.error({
          title: 'Connection token is NOT Valid',
        });
      }
    });
  };
  connectDropDown = (isUserPrivileged) => {
    // console.log("inside connectDropDown: ", isUserPrivileged);

    return (
      <Menu>
        {
          <Menu.Item disabled={!isUserPrivileged} onClick={this.urlModalToggle}>
            Update Base URL
          </Menu.Item>
        }
        <Menu.Item
          disabled={!isUserPrivileged}
          onClick={() => {
            this.setState({ proxyUrlModal: !this.state.proxyUrlModal });
          }}
        >
          Update proxy URLs
        </Menu.Item>
        <Menu.Item disabled={!isUserPrivileged} onClick={this.goToJiraLogin}>
          Update Token
        </Menu.Item>
        <Menu.Item
          disabled={!isUserPrivileged}
          onClick={this.onVerifyConnectionClick}
        >
          Verify Connection
        </Menu.Item>
        <Menu.Item
          danger
          disabled={!isUserPrivileged}
          onClick={this.disconnectOnClickModel}
        >
          Delete Connection
        </Menu.Item>
      </Menu>
    );
  };

  content_NotLinked = () => {
    const { skill } = this.props;
    return (
      <Card
        size='normal'
        loading={this.state.gridLoading}
        title='Jira Connection'
        bodyStyle={{ overflow: 'hidden' }}
        style={{ width: '100%' }}
      >
        <p>
          Connect to a Jira domain. Any Jira user (preferably one with Jira
          admin privileges) can perform this action
        </p>
        <Dropdown
          overlay={this.menu}
          trigger={['click']}
          placement='bottomLeft'
        >
          <Button>Connect</Button>
        </Dropdown>
      </Card>
    );
  };

  content_Linked = ({
    isUserPrivileged,
    col_span,
    isTokenisThere,
    style_for_double_columns,
    skillConnected,
    isFromCheckins,
    connectedAt,
    jiraDomainName,
    jiraUrl,
    isLinked,
  }) => {
    const { skill } = this.props;
    const connected_as = skill.connected_as
      ? skill.connected_as
      : skill.skill_metadata && skill.skill_metadata.connected_as;
    return (
      <Card
        style={{ width: '100%' }}
        loading={this.state.loadingUser}
        title={'Workspace Jira Account'}
        bodyStyle={{ overflow: 'hidden' }}
        extra={
          <Dropdown
            overlay={this.connectDropDown(isUserPrivileged)}
            placement='bottomLeft'
          >
            <Button shape='circle' type='link' icon={<SettingOutlined />} />
          </Dropdown>
        }
      >
        {
          <div>
            {isLinked && (
              <p>
                <Text type='secondary'>Connected to:</Text>{' '}
                <a href={jiraUrl} target='_blank'>
                  {jiraDomainName}
                </a>
                <br />
                <Text type='secondary'>Connected by:</Text>{' '}
                {this.props.isFromCheckins
                  ? this.props.jiraAdminUserData &&
                  (this.props.jiraAdminUserData.displayName ||
                    this.props.jiraAdminUserData.name)
                  : this.state.adminUserName}{' '}
                (
                {this.props.isFromCheckins
                  ? this.props.jiraAdminUserData &&
                  this.props.jiraAdminUserData.email
                  : this.state.adminMailId}
                )<br />
                {/* <br/> */}
                {/* {skill.connected_as && `Connected as: ${skill.connected_as.displayName} (${skill.connected_as.emailAddress})`} */}
                <Text type='secondary'> Connected at:</Text> {connectedAt}
                <br />
                {connected_as && connected_as.emailAddress ? (
                  <>
                    <Text type='secondary'> Connected as:</Text>{' '}
                    {connected_as.displayName} ({connected_as.emailAddress})
                  </>
                ) : (
                  connected_as &&
                  connected_as.displayName && (
                    <>
                      <Text type='secondary'> Connected as:</Text>{' '}
                      {connected_as.displayName}
                    </>
                  )
                )}
              </p>
            )}
          </div>
        }
      </Card>
    );
  };

  getContent = (data) => {
    const { skill } = this.props;
    return !data.isLinked
      ? this.content_NotLinked(data)
      : this.content_Linked(data);
  };
  changeDomainUrl = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  getModals = ({ domainName }) => {
    const sub_skill = this.props.match.params.sub_skill;
    let dynamicText = '';
    if (sub_skill === 'jira_software') {
      dynamicText = 'Helpdesk and Reports';
    } else if (sub_skill === 'jira_service_desk') {
      dynamicText = 'Projects and Reports';
    } else if (sub_skill === 'jira_reports') {
      dynamicText = 'Projects and Helpdesk';
    }
    return (
      <>
        {/*-----------------Disconnect Jira modal---------------*/}
        <Modal
          visible={this.state.disconnectModel}
          onCancel={this.disconnectOnClickModel}
          onOk={() => {
            this.updateSkill({
              linked: false,
              metadata: {},
              userName: null,
              userToken: null,
              globalGuestToken: null,
              globalProjectGuestToken: null,
            });
            this.getExistingGridConnections();
          }}
          okText={'Yes'}
          cancelText={'No'}
        >
          <Space
            direction='horizontal'
            size='middle'
            style={{ display: 'flex', alignItems: 'baseline' }}
          >
            <Space direction='vertical'>
              <ExclamationCircleOutlined
                style={{ color: 'rgba(250, 173, 20, 1)', fontSize: '22px' }}
              />
            </Space>
            <Space direction='vertical'>
              <Title level={5}>Confirm Jira connection deletion?</Title>
              <Text>
                You are currently connected to the Jira domain{' '}
                <strong>{domainName ? `'${domainName}'` : ''}</strong>
              </Text>
              <Text>
                Disconnecting the Jira domain will disconnect Jira access for
                the entire team. This will also disconnect Jira for{' '}
                {dynamicText}. Are you sure?
              </Text>
            </Space>
          </Space>
        </Modal>

        {this.state.getToken && (
          <Modal
            visible={this.state.getToken}
            // visible={this.showModal}
            style={{ top: 20 }}
            onCancel={this.doNotShowModal}
            onOk={this.submitTokenData}
            okText='Submit'
            title='Jira Token'
            width={540}
          >
            <JiraToken
              userToken={this.props.userToken.userToken}
              userName={this.props.userToken.userName}
              doNotShowModal={this.doNotShowModal}
              closeModal={true}
              showStyles={false}
              data={{ token: { done: false } }}
              shareMethods={this.acceptMethods.bind(this)}
              currentSkill={this.props.currentSkill}
            />
          </Modal>
        )}

        {this.state.urlModal && (
          <Modal
            title={'Jira Base URL'}
            visible={this.state.urlModal}
            onCancel={this.urlModalToggle}
            onOk={this.submitNewUrl}
            okText='Submit'
          >
            <Form layout='vertical' ref={this.formRef}>
              <Form.Item
                className={
                  localStorage.getItem('theme') == 'dark' && 'form_label_dark'
                }
              >
                <Alert
                  description={
                    <div>
                      The Base URL is the URL via which users access Jira
                      applications. The base URL must be set to the same URL by
                      which browsers will be viewing your Jira instance. Troopr
                      used the Jira Base URL for some REST API calls and also to
                      generate link URL for issues.
                      <br />
                      <br />
                      Change the Base URL for your Jira instance only if it is
                      different from what is mentioned below. Typically there is
                      no need to change this value, but in some cases like
                      migrated Jira instance, the Base URL can be different from
                      the generated one below.
                    </div>
                  }
                  type='warning'
                />
                <br />
                <Input
                  type='url'
                  value={this.state.domain_url}
                  onChange={this.changeDomainUrl}
                  name='domain_url'
                  className={` input-bg ${localStorage.getItem('theme') == 'dark' && 'autofill_dark'
                    }`}
                />
              </Form.Item>
            </Form>
          </Modal>
        )}

        <JiraServerModal
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.newConnectionModal}
          onCancel={this.handleCancel}
          // onCreate={this.handleCreate}
          serverConnection={true}
        />

        {this.state.proxyUrlModal && (
          <ProxyUrlModal
            proxyUrlModal={this.state.proxyUrlModal}
            setProxyUrlModal={(val) => {
              this.setState({ proxyUrlModal: val });
            }}
            skill={this.props.skill}
            updateSkill={this.props.updateSkill}
            currentSkill={this.props.currentSkill}
          />
        )}
      </>
    );
  };

  goToUserJiraLogin = async () => {
    const { skills, isWorkspaceAdmin } = this.props;
    if (!isWorkspaceAdmin) {
      return message.warn(`Action Restricted`);
    }
    const jiraSkill = this.props.skills.find((skill) => skill.key === 'jira');

    let servertype =
      jiraSkill &&
      jiraSkill.skill_metadata.metadata &&
      jiraSkill.skill_metadata.metadata.server_type;
    const queryParams = queryString.parse(this.props.location.search);
    if (servertype && servertype === 'jira_server_oauth') {
      let url = await guestOauthTokensForUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill,
        queryParams
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else if (servertype && servertype === 'jira_cloud_oauth') {
      let url = await getGuestOauthTokensForCloudUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill,
        queryParams
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else {
      message.error('Error authorizing guest token');
      // const url = `/${this.props.match.params.wId}/jira_user_oauth/${this.props.match.params.skill_id}`;
      // window.open(url, "_blank");
    }
  };

  removeGuestAuthorizationConfirm = async () => {
    const { isWorkspaceAdmin } = this.props;

    if (!isWorkspaceAdmin) {
      return message.warn(`Action Restricted`);
    }

    Modal.confirm({
      title: 'Revoke Guest Facilitation',
      icon: <ExclamationCircleOutlined />,
      content: <p>Are you sure you want revoke permissions?</p>,
      onOk: () => this.removeGuestAuthorization(),
      onCancel: () => { },
    });
  };

  removeGuestAuthorization = () => {
    const data =
      this.props.match.params.sub_skill === 'jira_software'
        ? { globalProjectGuestToken: null }
        : { globalGuestToken: null };
    this.props.updateSkill(
      this.props.match.params.skill_id,
      this.props.match.params.wId,
      data
    );
  };

  toggleChangeAttributeField = () => {
    this.setState({
      showAttributeTextField: !this.state.showAttributeTextField,
    });
    //  this.setState({defaultAttributeTextTemp:this.state.attributeText})
    this.setState({ attributeText: this.state.attributeText });
  };

  resetAttributeText = async () => {
    let data = {
      attributeText: attributeText,
    };
    this.props.updateSkill(
      this.props.match.params.skill_id,
      this.props.match.params.wId,
      data,
      null,
      false
    );
    this.setState({
      attributeText: attributeText,
    });
  };

  cancelAttributeChange = () => {
    this.setState({
      showAttributeTextField: false,
      attributeText: this.props.skill.skill_metadata
        ? this.props.skill.skill_metadata.attributeText
        : this.props.skill.attributeText,
    });
  };
  saveAttributeTextChange = async () => {
    let data = { attributeText: this.state.attributeText };
    this.props.updateSkill(
      this.props.match.params.skill_id,
      this.props.match.params.wId,
      data,
      null,
      false
    );
    this.toggleChangeAttributeField();
  };

  anchor_classname = localStorage.getItem('dark')
    ? 'anchor-links-dark'
    : 'anchor-links';

  render() {
    const { isFromCheckins, currentSkill, isWorkspaceAdmin } = this.props;
    const { members, user } = this.props;
    const { sub_skill } = this.props.match.params;
    const jiraSkill =
      currentSkill && currentSkill.skill_metadata
        ? currentSkill.skill_metadata
        : currentSkill;
    let isAdmin = this.props.isWorkspaceAdmin;

    let currentUserId = this.props.currentUser._id;
    //let isUserPrivileged = ((currentUserId == this.state.adminUserId) || (this.state.isAdmin));
    let isUserPrivileged =
      currentUserId ==
      (this.props.isFromCheckins
        ? this.props.jiraAdminUserData && this.props.jiraAdminUserData.user_id
        : this.state.adminUserId) || isAdmin;
    const col_span = 24;
    const { skill } = this.props;
    // console.log("this is new skill",skill)

    // console.log("skill: ", skill);

    let jiraUrl;
    let jiraDomainName;
    let isLinked = skill.skill_metadata
      ? skill.skill_metadata.linked
      : skill.linked;
    let domainName;
    let connectedAt;

    // console.log("skill---->",skill)
    // let time = skill.metadata.installationInfo ? skill.metadata.installationInfo.created_at : ''
    // let date = moment.utc(time).format('MMM Do ha');
    let type = null;
    if (isLinked) {
      let type = skill.skill_metadata
        ? skill.skill_metadata &&
        (skill.skill_metadata.metadata.server_type == 'jira_server' ||
          skill.skill_metadata.metadata.server_type == 'jira_server_oauth')
        : skill.metadata &&
        (skill.metadata.server_type === 'jira_server' ||
          skill.metadata.server_type === 'jira_server_oauth');
      let time = skill.skill_metadata
        ? skill.skill_metadata.metadata.createdAt
        : skill.metadata.createdAt;
      connectedAt = moment(time).format('MMM Do h:mm A Z');
      if (type) {
        jiraUrl = skill.skill_metadata
          ? skill.skill_metadata.metadata.domain_url
          : skill.metadata.domain_url;
        jiraDomainName = jiraUrl;
      } else {
        let name = skill.skill_metadata
          ? skill.skill_metadata.metadata.domain_name
          : skill.metadata.domain_name;
        jiraUrl = skill.skill_metadata
          ? skill.skill_metadata.metadata.domain_url
          : skill.metadata.domain_url
            ? skill.metadata.domain_url
            : `https://${name}.atlassian.net`;

        jiraDomainName = jiraUrl;
      }

      // domainName=skill.skill_metadata?
      domainName = skill.skill_metadata
        ? type
          ? skill.skill_metadata.metadata.domain_url
          : skill.skill_metadata.metadata.domain_name
        : type
          ? skill.metadata.domain_url
          : skill.metadata.domain_name;
    }

    const checkingSkill1 =
      this.props.currentSkill.skill_metadata &&
      this.props.currentSkill.skill_metadata &&
      this.props.currentSkill.skill_metadata.metadata &&
      this.props.currentSkill.skill_metadata.metadata.server_type !=
      'jira_server' &&
      this.props.currentSkill.skill_metadata.metadata.server_type !=
      'jira_server_oauth' &&
      this.props.currentSkill.skill_metadata.metadata.server_type !=
      'jira_cloud_oauth';
    const checkingSkill2 =
      this.props.currentSkill &&
      this.props.currentSkill.metadata &&
      this.props.currentSkill.metadata.server_type != 'jira_server' &&
      this.props.currentSkill.metadata.server_type != 'jira_server_oauth' &&
      this.props.currentSkill.metadata.server_type != 'jira_cloud_oauth';
    const skillConnected = checkingSkill1 || checkingSkill2;
    const isTokenisThere = skillConnected && this.props.userToken.userName;
    const style_for_double_columns = { display: 'flex' };

    const data = {
      isUserPrivileged,
      col_span,
      isTokenisThere,
      style_for_double_columns,
      skillConnected,
      isFromCheckins,
      connectedAt,
      jiraDomainName,
      jiraUrl,
      isLinked,
    };
    const showAnchor =
      (sub_skill === 'jira_software' || sub_skill === 'jira_service_desk') &&
      isLinked;

    const globalGuestToken =
      jiraSkill && sub_skill === 'jira_software'
        ? jiraSkill.globalProjectGuestToken || null
        : jiraSkill.globalGuestToken;

    const type_of_task =
      sub_skill === 'jira_service_desk' ? 'request' : 'issue';
    const type_of_task_upper_case =
      sub_skill === 'jira_service_desk' ? 'Request' : 'Issue';

    return isFromCheckins ? (
      <>
        {this.getContent(data)} {this.getModals({ domainName })}{' '}
      </>
    ) : (
      <Layout style={{ marginLeft: 0 }}>
        <Row>
          <Col span={showAnchor ? 20 : 24}>
            <Content>
              {/* <div> */}
              <div /* style={ showAnchor ? {height:"85vh" , overflowY: 'scroll', overflowX:'hidden'} : {}} */
              >
                <Row
                  style={{
                    marginBottom: sub_skill === 'jira_reports' ? '' : 600,
                  }}
                  gutter={this.props.global_row_gutter}
                  className='main-content-padding'
                >
                  <Col span={col_span}>
                    <Alert
                      message='Configurations in this page apply to the entire workspace'
                      type='warning'
                      showIcon
                    // style={{ width: "calc(100% - 16px)",maxWidth:984, marginBottom:16 }}
                    />
                  </Col>

                  {!isLinked ? (
                    <Col span={col_span}>
                      {/*-----------------------------------Jira Not Connected--------------------------------*/}
                      {this.content_NotLinked(data)}
                    </Col>
                  ) : (
                    <>
                      {this.props.currentSkill.skill_metadata &&
                        (this.props.currentSkill.skill_metadata.metadata
                          .server_type === 'jira_cloud' ||
                          this.props.currentSkill.skill_metadata.metadata
                            .server_type === 'jira_server') &&
                        !this.props.currentSkill.skill_metadata.metadata
                          .webhook ? (
                        <Col span={col_span}>
                          <Card
                            style={{ width: '100%' }}
                            title='Webhook'
                            bodyStyle={{ height: '150px', overflow: 'hidden' }}
                            extra={
                              <Button onClick={this.goToJiraNotifSetup}>
                                Configure
                              </Button>
                            }
                          >
                            <p>
                              This configuration can be completed by any Jira
                              admin. This step is required for you and your team
                              members to start receiving notifications from Jira
                              when issues are created or updated.
                            </p>
                          </Card>
                        </Col>
                      ) : (
                        <>
                          {this.props.currentSkill.metadata &&
                            (this.props.currentSkill.metadata.server_type ===
                              'jira_cloud' ||
                              this.props.currentSkill.metadata.server_type ===
                              'jira_server') &&
                            !this.props.currentSkill.metadata.webhook ? (
                            <Col span={col_span}>
                              <Card
                                style={{ width: '100%' }}
                                title='Webhook'
                                bodyStyle={{
                                  height: '150px',
                                  overflow: 'hidden',
                                }}
                                extra={
                                  <Button onClick={this.goToJiraNotifSetup}>
                                    Configure
                                  </Button>
                                }
                              >
                                <p>
                                  This configuration can be completed by any
                                  Jira admin. This step is required for you and
                                  your team members to start receiving
                                  notifications from Jira when issues are
                                  created or updated.
                                </p>
                              </Card>
                            </Col>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                      {/*------------------------------------------Jira Connected-------------------------------------*/}
                      <Col
                        span={col_span}
                        style={{ display: 'grid' }}
                        id='account'
                      >
                        {this.content_Linked(data)}
                      </Col>

                      {(sub_skill === 'jira_software' ||
                        sub_skill === 'jira_service_desk') && (
                          <>
                            {this.props.isWorkspaceAdmin && (
                              <Col
                                span={col_span}
                                id='g_personal_notification'
                              // xs={{ span: 24 }}
                              // sm={{ span: 24 }}
                              // lg={{ span: 12 }}
                              // xxl={{ span: 12 }}
                              // style={{ maxWidth: "1000px" }}
                              >
                                {/* {(currentSkillUser.token_obj && currentSkillUser.token_obj.type !== "Guest" ||) && */}
                                {/* https://stackoverflow.com/questions/37949981/call-child-method-from-parent */}
                                <JiraPersonalNotification
                                  skill={this.props.skill}
                                  skillView={this.props.skillView}
                                  setClick={(click) => {
                                    this.clickChild = click;
                                  }}
                                />
                                {/* } */}
                              </Col>
                            )}
                            <Col span={col_span} id='issue_configs'>
                              <Card
                                title={`${sub_skill === 'jira_service_desk'
                                  ? 'Request'
                                  : 'Issue'
                                  } creation behaviour`}
                              >
                                {(sub_skill === 'jira_service_desk' ||
                                  sub_skill === 'jira_software') && (
                                    <>
                                      <DefaultsSelection />
                                      <Divider />
                                    </>
                                  )}

                                {sub_skill === 'jira_service_desk' && (
                                  <>
                                    <RequestTypeRestriction globalLevel={true} />
                                    <Divider />
                                  </>
                                )}
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginBottom: 8,
                                  }}
                                >
                                  <div style={{ marginRight: 8 }}>
                                    <Tooltip title='This configuration will be used in Troopr Projects and Troopr Helpdesk'>
                                      <InteractionTwoTone twoToneColor='orange' />
                                    </Tooltip>{' '}
                                    <Text strong>
                                      Task It Response in thread:{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      {sub_skill === 'jira_service_desk'
                                        ? 'When a Slack message is converted to a Jira request using "Task It" message action, the message containing Jira request details will be sent in original message thread. If disabled request message will be sent as new message in channel.'
                                        : 'When a Slack message is converted to an issue using Task It message action, the issue card response will be sent in original message thread. If disabled issue card will be sent as new message.'}
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={!isUserPrivileged}
                                      checked={this.state.taskItResponseInThread}
                                      onChange={() =>
                                        this.unfurlOptionsHandler(
                                          'taskItResponseInThread'
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                {sub_skill === 'jira_software' && (
                                  <>
                                    <Divider />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        marginBottom: 8,
                                      }}
                                    >
                                      <div style={{ marginRight: 8 }}>
                                        <Text strong>
                                          /t create Command Response:{' '}
                                        </Text>
                                        <Text type='secondary'>
                                          When a Slack message is converted to an
                                          issue using <code>/t create</code>{' '}
                                          command, the issue card response will be
                                          sent as a public message with thread. If
                                          disabled issue card will be sent as a
                                          private message without any thread.
                                        </Text>
                                      </div>
                                      <div>
                                        <Switch
                                          disabled={!isUserPrivileged}
                                          checked={
                                            this.state.createCommandResponseConfig
                                          }
                                          onChange={() =>
                                            this.unfurlOptionsHandler(
                                              'createCommandResponseConfig'
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div style={{ marginRight: 8 }}>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text>
                                        <strong>Attribution: </strong>
                                      </Text>
                                      <Text type='secondary'>{`When a Jira issue is created in Slack channel, Troopr will add this attribution text to the bottom of issue description. (Max length 256)`}</Text>
                                    </div>
                                    {!this.state.showAttributeTextField && (
                                      <div>
                                        <Text type='secondary' italic>
                                          {this.state.attributeText
                                            ? this.state.attributeText
                                            : attributeText}
                                        </Text>
                                      </div>
                                    )}
                                    {this.state.showAttributeTextField && (
                                      <div>
                                        {' '}
                                        <Input
                                          maxLength={256}
                                          onChange={(e) =>
                                            this.setState({
                                              attributeText: e.target.value,
                                            })
                                          }
                                          value={this.state.attributeText}
                                        ></Input>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        display: 'flex',
                                        marginTop: 16,
                                        columnGap: 16,
                                        rowGap: 8,
                                      }}
                                    >
                                      <Button
                                        disabled={
                                          this.state.attributeText == '' ||
                                          !this.state.showAttributeText
                                        }
                                        onClick={() =>
                                          this.state.showAttributeTextField
                                            ? this.saveAttributeTextChange()
                                            : this.toggleChangeAttributeField()
                                        }
                                      >
                                        {this.state.showAttributeTextField
                                          ? 'Save'
                                          : 'Change Text'}
                                      </Button>

                                      {this.state.showAttributeTextField && (
                                        <Button
                                          onClick={() =>
                                            this.cancelAttributeChange()
                                          }
                                        >
                                          Cancel
                                        </Button>
                                      )}

                                      {!this.state.showAttributeTextField &&
                                        this.state.attributeText &&
                                        this.state.attributeText !==
                                        attributeText && (
                                          <Button
                                            onClick={() =>
                                              this.resetAttributeText()
                                            }
                                          >
                                            Reset Text
                                          </Button>
                                        )}
                                    </div>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={!isUserPrivileged}
                                      checked={this.state.showAttributeText}
                                      onChange={() => {
                                        this.unfurlOptionsHandler(
                                          'showAttributeText'
                                        );
                                        this.setState({
                                          showAttributeText:
                                            !this.state.showAttributeText,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>

                                {/* <Divider /> */}
                                {/* <Text><Tooltip title="This configuration will be used in Troopr Projects and Troopr Helpdesk"><InteractionTwoTone twoToneColor="orange" /></Tooltip>{' '}<strong>Emoji creation:{' '}</strong>Create a Jira issue when the emoji is added to slack message. Invite Troopr to the channel before trying emoji creation.</Text> */}
                                {/* <CustomEmojiForCreation /> */}
                              </Card>
                            </Col>
                          </>
                        )}

                      {sub_skill === 'jira_software' && (
                        <Col
                          span={col_span}
                          style={{ display: 'grid' }}
                          id='global-issue-preview-behaviour'
                        >
                          {jiraSkill && (
                            <Card
                              title={'Issue Preview (Unfurl)'}
                              key='0'
                              extra={
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Switch
                                    checked={jiraSkill.globalProjectIsUnfurl}
                                    disabled={!isWorkspaceAdmin}
                                    onChange={() =>
                                      this.updateSkillData({
                                        globalProjectIsUnfurl:
                                          !jiraSkill.globalProjectIsUnfurl,
                                      })
                                    }
                                  />
                                </div>
                              }
                            >
                              <Text type='secondary'>
                                Show additional information about Jira{' '}
                                {type_of_task} when its is mentioned in Slack
                              </Text>
                              <br />

                              <Text type='warning'>
                                Note that unfurl will not work if ‘Auto Create{' '}
                                {type_of_task}’ is enabled in channel
                                configuration.
                              </Text>

                              <Divider />
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <Text>
                                    <strong>Link Preview:</strong>{' '}
                                  </Text>
                                  <Text type='secondary'>
                                    Allow Troopr to generate {type_of_task}{' '}
                                    preview for Jira {type_of_task}
                                    links. Example:
                                    https://acme.atlassian.net/servicedesk/customer/portal/1/SD-1230
                                  </Text>
                                </div>
                                <div>
                                  <Switch
                                    disabled={
                                      !jiraSkill.globalProjectIsUnfurl ||
                                      !isWorkspaceAdmin
                                    }
                                    checked={
                                      jiraSkill.globalProjectIsUnfurlLink
                                    }
                                    onChange={() =>
                                      this.updateSkillData({
                                        globalProjectIsUnfurlLink:
                                          !jiraSkill.globalProjectIsUnfurlLink,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <Divider />
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <Text>
                                    <strong>Preview in Thread:</strong>{' '}
                                  </Text>
                                  <Text type='secondary'>
                                    Expanded {type_of_task} context will be sent
                                    as Slack messsage in the original message
                                    thread.
                                  </Text>
                                </div>
                                <div>
                                  <Switch
                                    disabled={
                                      !jiraSkill.globalProjectIsUnfurl ||
                                      !isWorkspaceAdmin
                                    }
                                    checked={
                                      jiraSkill.globalProjectUnfurlResponseInThread
                                    }
                                    onChange={() =>
                                      this.updateSkillData({
                                        globalProjectUnfurlResponseInThread:
                                          !jiraSkill.globalProjectUnfurlResponseInThread,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <Divider />
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <Text>
                                    <strong>Auto start thread sync:</strong>
                                  </Text>
                                  <Text type='secondary'>
                                    {' '}
                                    This will automatically start thread sync
                                    during {type_of_task} creation and{' '}
                                    {type_of_task} preview
                                  </Text>
                                </div>
                                <div>
                                  <Popconfirm
                                    title={
                                      <>
                                        This action will{' '}
                                        {jiraSkill.globalProjectIsThreadSync
                                          ? 'disable'
                                          : 'enable'}{' '}
                                        active bi-directional realtime updates
                                        <br />
                                        between Slack and Jira everytime a Jira
                                        issue preview is created in Slack by
                                        Troopr.
                                        <br /> Are you sure you want to change
                                        this behavior for everyone in your
                                        workspace?
                                      </>
                                    }
                                    placement='left'
                                    onConfirm={() => {
                                      this.updateSkillData({
                                        globalProjectIsThreadSync:
                                          !jiraSkill.globalProjectIsThreadSync,
                                      });
                                    }}
                                    disabled={
                                      !jiraSkill.globalProjectIsUnfurl ||
                                      !this.props.isWorkspaceAdmin
                                    }
                                    okText={
                                      jiraSkill.globalProjectIsThreadSync
                                        ? 'Disable'
                                        : 'Enable'
                                    }
                                    cancelText='No'
                                    dis
                                  >
                                    <Switch
                                      disabled={
                                        !jiraSkill.globalProjectIsUnfurl ||
                                        !this.props.isWorkspaceAdmin
                                      }
                                      checked={
                                        jiraSkill.globalProjectIsThreadSync
                                      }
                                    // onChange={() =>
                                    //   this.updateSkillData({
                                    //     globalProjectIsThreadSync:
                                    //       !jiraSkill.globalProjectIsThreadSync,
                                    //   })
                                    // }
                                    />
                                  </Popconfirm>
                                </div>
                              </div>
                            </Card>
                          )}
                        </Col>
                      )}

                      {(sub_skill === 'jira_software' ||
                        sub_skill === 'jira_service_desk') && (
                          <Col span={col_span} id='global_guest_facility'>
                            <Card
                              title={
                                <>
                                  <Text style={{ marginRight: 8 }}>
                                    Global Guest facilitation
                                  </Text>
                                  {globalGuestToken &&
                                    globalGuestToken.user_obj && (
                                      <Tag color='success'>Enabled</Tag>
                                    )}
                                </>
                              }
                            >
                              <>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginBottom: 8,
                                  }}
                                >
                                  <div style={{ marginRight: 16 }}>
                                    <Text strong>Guest facilitation: </Text>
                                    <Text type='secondary'>
                                      Troopr can facilitate Jira actions for users
                                      who have not verified their Jira account
                                      yet. This feature can be activated by
                                      authorizing a facilitator account below.
                                    </Text>
                                  </div>
                                  <div>
                                    {!globalGuestToken && (
                                      <Button
                                        disabled={!this.props.isWorkspaceAdmin}
                                        onClick={() => this.goToUserJiraLogin()}
                                      >
                                        {' '}
                                        Authorize
                                      </Button>
                                    )}
                                    {globalGuestToken && (
                                      <>
                                        <br />
                                        <Button
                                          danger
                                          onClick={
                                            this.removeGuestAuthorizationConfirm
                                          }
                                          disabled={!this.props.isWorkspaceAdmin}
                                        >
                                          {' '}
                                          Remove Authorization
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div>
                                  {globalGuestToken &&
                                    globalGuestToken.user_obj && (
                                      <Text>
                                        Facilitator account:{' '}
                                        {globalGuestToken.user_obj.displayName ||
                                          globalGuestToken.user_obj.name ||
                                          globalGuestToken.user_obj.emailAddress}
                                      </Text>
                                    )}
                                </div>
                                {globalGuestToken &&
                                  globalGuestToken.user_obj && (
                                    <>
                                      <div>
                                        {(sub_skill === 'jira_service_desk' ||
                                          sub_skill === 'jira_software') &&
                                          jiraSkill && (
                                          /* jiraSkill.skill_metadata && */ <div id='gloabl_guest_user_restriction'>
                                              <Divider />
                                              <GlobalGuestTokenRestriction />
                                              <Divider />
                                              <ProjectRestriction
                                                isGlobalProjectRestriction={true}
                                                projectLoading={
                                                  this.state.projectLoading
                                                }
                                              />
                                              <Divider />
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  flexDirection: 'row',
                                                  justifyContent: 'space-between',
                                                  marginBottom: 8,
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    marginBottom: 8,
                                                    width: '50vw',
                                                  }}
                                                >
                                                  <Text>
                                                    <strong>
                                                      Allow guest users to unfurl:{' '}
                                                    </strong>
                                                  </Text>
                                                  <Text type='secondary'>
                                                    When{' '}
                                                    {sub_skill ===
                                                      'jira_service_desk'
                                                      ? 'request'
                                                      : 'issue'}{' '}
                                                    preview is enabled and a user
                                                    who has not verified their
                                                    Jira account mentions a Jira{' '}
                                                    {sub_skill ===
                                                      'jira_service_desk'
                                                      ? 'request'
                                                      : 'issue'}{' '}
                                                    in Slack, the facilitator's
                                                    account will be used to make
                                                    the{' '}
                                                    {sub_skill ===
                                                      'jira_service_desk'
                                                      ? 'request'
                                                      : 'issue'}{' '}
                                                    preview.{' '}
                                                  </Text>
                                                </div>
                                                <div>
                                                  <Switch
                                                    disabled={
                                                      !this.props.isWorkspaceAdmin
                                                    }
                                                    onChange={(checked) =>
                                                      this.updateSkillData(
                                                        sub_skill ===
                                                          'jira_software'
                                                          ? {
                                                            allowGuestUnfurlInProjectsGlobal:
                                                              checked,
                                                          }
                                                          : sub_skill ===
                                                            'jira_service_desk'
                                                            ? {
                                                              allowGuestUnfurlInHelpdeskGlobal:
                                                                checked,
                                                            }
                                                            : {}
                                                      )
                                                    }
                                                    checked={
                                                      sub_skill ===
                                                        'jira_software'
                                                        ? jiraSkill.allowGuestUnfurlInProjectsGlobal
                                                        : sub_skill ===
                                                          'jira_service_desk'
                                                          ? jiraSkill.allowGuestUnfurlInHelpdeskGlobal
                                                          : false
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </>
                                  )}
                              </>
                            </Card>
                          </Col>
                        )}

                      {skillConnected && (
                        <Col span={col_span} style={style_for_double_columns}>
                          <Card
                            style={{ width: '100%' }}
                            loading={this.state.loadingToken}
                            title='API Token'
                            size='small'
                            bodyStyle={{ overflow: 'hidden' }}
                            extra={
                              isTokenisThere ? (
                                <Dropdown
                                  overlay={
                                    <Menu>
                                      <Menu.Item
                                        disabled={!isUserPrivileged}
                                        onClick={this.getToken}
                                      >
                                        {isTokenisThere
                                          ? 'Update'
                                          : 'Add Token'}
                                      </Menu.Item>
                                      <Menu.Item
                                        disabled={!isUserPrivileged}
                                        danger
                                        loading={this.state.loading}
                                      >
                                        {!isUserPrivileged ? (
                                          'Delete'
                                        ) : (
                                          <Popconfirm
                                            title='Are you sure you want to delete the token?'
                                            //  disabled={!isUserPrivileged}
                                            onConfirm={this.deleteToken}
                                            okText='Yes'
                                            cancelText='No'
                                          >
                                            Delete
                                          </Popconfirm>
                                        )}
                                      </Menu.Item>
                                    </Menu>
                                  }
                                  placement='bottomLeft'
                                >
                                  <Button
                                    type='link'
                                    icon={<SettingOutlined />}
                                  />
                                </Dropdown>
                              ) : (
                                <Button
                                  disabled={!isUserPrivileged}
                                  onClick={this.getToken}
                                >
                                  {isTokenisThere ? 'Update' : 'Add Token'}
                                </Button>
                              )
                            }
                          >
                            {/* <Alert
                        message={isTokenisThere ? `Connected account: ${this.props.userToken.userName}` : `Token is not configured for this account`}
                        metadata type={isTokenisThere ? "success" : "warning"}
                        showIcon
                        description="Jira token is necessary for Troopr Jira integration to function optimally. This configuration can be completed by any Jira admin"
                      ></Alert> */}

                            {isTokenisThere ? (
                              <>
                                <Text type='secondary'>Token owner: </Text>
                                <Text>{this.props.userToken.userName}</Text>
                              </>
                            ) : (
                              <>
                                <Text type='secondary'>
                                  Token is not configured for this account
                                </Text>
                              </>
                            )}
                          </Card>
                        </Col>
                      )}
                      <>
                        <Col span={col_span}>
                          <div
                            style={{ marginBottom: '8px' }}
                            id='atlassian_billing'
                          >
                            <JiraBilling
                              payment={this.state.payment}
                              workspace={this.props.workspace}
                              updatePayment={this.updatePayment}
                              isUserPrivileged={isUserPrivileged}
                            />
                          </div>
                        </Col>
                      </>
                    </>
                  )}

                  {this.getModals({ domainName })}
                </Row>
              </div>
            </Content>
          </Col>
          {sub_skill !== 'jira_reports' && isLinked && (
            <Col span={4}>
              <Anchor
                getContainer={() =>
                  document.getElementById('anchor-scroll-content')
                }
                style={{ marginRight: '16px' }}
              >
                <Link
                  href='#account'
                  title='Workspace Jira Account'
                  className={this.anchor_classname}
                />
                <Link
                  href='#issue_configs'
                  title={`${sub_skill === 'jira_service_desk' ? 'Request' : 'Issue'
                    } creation settings`}
                  className={this.anchor_classname}
                />
                {sub_skill === 'jira_software' && (
                  <Link
                    href='#global-issue-preview-behaviour'
                    title={'Issue Preview (Unfurl)'}
                    className={this.anchor_classname}
                  />
                )}
                {(sub_skill === 'jira_software' ||
                  sub_skill === 'jira_service_desk') && (
                    <Link
                      href='#global_guest_facility'
                      title='Global Guest facilitation'
                      className={this.anchor_classname}
                    />
                  )}

                {!(
                  this.props.workspace.billing_status == 'paid' &&
                  this.state.payment &&
                  this.state.payment.payment_app !== 'jira'
                ) && (
                    <Link
                      href='#atlassian_billing'
                      title='Atlassian Billing Link'
                      className={this.anchor_classname}
                    />
                  )}
              </Anchor>
            </Col>
          )}
        </Row>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workspace: state.common_reducer.workspace,
    assistant_skills: state.skills,
    user: state.common_reducer.user,
    userData: state.skills,
    issues: state.skills.issues,
    channelDefault: state.skills.channelDefault,
    personalChannelDefault: state.skills.personalChannelDefault,
    currentUser: state.auth.user,
    guestManager: state.jiraGuest.jiraGuestManager,
    guestUsers: state.jiraGuest.jiraGuestUsers,
    jiraUser: state.skills.currentSkillUser,
    userToken: state.skills.userData,
    currentSkill: state.skills.currentSkill,
    skills: state.skills.skills,

    isWorkspaceAdmin: state.common_reducer.isAdmin,
    global_row_gutter: state.common_reducer.global_row_gutter,
    projects: state.skills.projects,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateSkill,
    getIssues,
    getProject,
    getAssisantSkills,
    // getJiraGuestManager,
    // getJiraGuestUsers,
    submitTokenData,
    getUserToken,
    getUser,
    // addBasicAuth,
    setWorkspace,
    setSkill,
    setCurrentSkill,
    updateAssisantSkills,
    searchJiraProjects,
  })(JiraConfiguration)
);
